import React, { useState } from 'react'
import { Button, Result } from 'antd'
import Dropzone from 'react-dropzone'
import { useTranslation } from 'react-i18next'
import { MdOutlineMarkEmailRead } from 'react-icons/md'
import { useMutation } from 'react-query'
import { useParams } from 'react-router-dom'
import AuthService from '../../../services/AuthService'

import * as s from './styles'

const Auth = new AuthService()

const ResumeUpload = () => {
  const { t } = useTranslation(['common', 'talentArea'], {
    useSuspense: false,
  })

  const [file, setFile] = useState(null)
  const [uploadSent, setUploadSent] = useState(false)

  const { id } = useParams()

  const { mutate: uploadFile } = useMutation(
    async () => {
      const formData = new FormData()

      formData.append('uri', file)
      formData.append('name', file?.name)
      formData.append('type', 'resume')
      formData.append('candidateId', id)

      Auth.fetch('/lambda-candidate-file', {
        method: 'POST',
        body: formData,
      })

      setUploadSent(true)
    },
    {
      onError: (error) => {
        console.error(error)
      },
    },
  )

  if (uploadSent) {
    return (
      <Result
        status="success"
        icon={<MdOutlineMarkEmailRead size={40} color="#02CD9A" />}
        title={t('talentArea:magic.uploaded.title')}
        subTitle={t('talentArea:magic.uploaded.content')}
      />
    )
  }

  const onDropFile = (files) => {
    setFile(files[0])
  }

  const onCancel = () => {}

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
      }}
    >
      <s.Wrapper>
        <span>{t('talentArea:magic.title')}</span>
        <span>{t('talentArea:magic.supportedFiles')}</span>
        <s.ResumeUpload>
          <Dropzone
            onDrop={onDropFile}
            onFileDialogCancel={onCancel}
            multiple={false}
          >
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()}>
                <input data-testid="drop-input" {...getInputProps()} />
                <div className="dropzone-content">
                  <p>{t('common:dragAndDropFile')}</p>
                </div>
              </div>
            )}
          </Dropzone>
          {file?.name}
        </s.ResumeUpload>
        <Button
          style={{
            margin: 'auto',
            marginTop: '10px',
          }}
          className="white-btn"
          onClick={uploadFile}
          disabled={!file}
        >
          {t('talentArea:magic.upload')}
        </Button>
      </s.Wrapper>
    </div>
  )
}

export default ResumeUpload
